/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBracketsAngle = createReactComponent("brackets-angle", "IconBracketsAngle", [
  ["path", { d: "M8 4l-5 8l5 8", key: "svg-0" }],
  ["path", { d: "M16 4l5 8l-5 8", key: "svg-1" }]
]);

export { IconBracketsAngle as default };
//# sourceMappingURL=IconBracketsAngle.js.map
